import React from 'react';

import { Badge } from '../../index';

interface BooleanCellProps {
  value: unknown;
  children: React.ReactNode;
  trueLabel?: string;
  falseLabel?: string;
  trueColor?: string;
  falseColor?: string;
  variant?: 'solid' | 'subtle' | 'outline';
}

export const BooleanCell: React.FC<BooleanCellProps> = ({
  value,
  children,
  trueLabel = 'Yes',
  falseLabel = 'No',
  trueColor = 'green',
  falseColor = 'red',
  variant = 'subtle',
}) => {
  // If not a boolean, render children as fallback
  if (typeof value !== 'boolean') {
    return <>{children}</>;
  }

  const isTrue = value;
  const label = isTrue ? trueLabel : falseLabel;
  const color = isTrue ? trueColor : falseColor;

  // For subtle variant, use lighter background
  const badgeProps = {
    colorPalette: color as
      | 'brand'
      | 'gray'
      | 'blue'
      | 'green'
      | 'orange'
      | 'purple'
      | 'red'
      | 'yellow',
    variant: variant as 'solid' | 'subtle' | 'outline',
  };

  return <Badge {...badgeProps}>{label}</Badge>;
};
